import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BotService {
  private headers = {headers: new HttpHeaders({'Authorization': `Bearer ${environment['anythingLlmKey']}`,'Accept': 'application/json'})};
  private sessionId: number | null = null;

  constructor(private http: HttpClient) { }



  sendMessage(message:string): Observable<any> {
    const body = {
      ws_id: this.sessionId,
      workspace: environment['projectName'],
      question: message
    }
    return this.http.post(`${environment.apiUrl}/bot/ask`, body, this.headers);
  }

  setSessionId(sessionId: number): void {
    this.sessionId = sessionId;
  }

  isEmpty(): boolean {
    return this.sessionId === null;
  }
}
